
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Attachment, Task } from '@/types';
import API from '@/lib/API';

@Component
export default class AttachmentDeleteDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Object) readonly attachment!: Attachment;
  @Prop(Object) readonly task!: Task;

  // Se true, è utilizzato all'interno di una Connection
  @Prop({ type: Boolean, default: false }) readonly connection!: boolean

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange()`); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  async onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onDelete() {
    console.log(`${this.constructor.name}: onDelete()`); // eslint-disable-line no-console

    this.loading = true;

    if (this.task || this.connection) {
      // Comunica ad AttachmentsList l'elenco degli id da cancellare
      // (si occuperà lui eventualmente di aggiungerli al task/lead)
      this.$emit('delete', this.attachment.id);
    } else {
      await API.removeLeadAttachments(this.lead.id, {
        attachments: [this.attachment.id],
      });
    }

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
